import { inject } from 'mobx-react';
import { LinksComponent } from './component';
export const Links = inject(({ router }) => ({
    currentPath: router.currentPath,
    navigate: router.navigate,
}))(LinksComponent);
//# sourceMappingURL=index.js.map